<div class="title">
  <mat-icon>person</mat-icon>
  Ownership
</div>
<div class="description">SELECT THE OWNERS TO FILTER BY</div>

<div class="lightMode search">
  <framework-search-profiles
    (chosenProfile)="add($any($event))"
    [placeholder]="'Search Users'"
    [resetOnSelected]="true"
  >
  </framework-search-profiles>
</div>

<div class="options">
  <elements-filter-chip
    icon="person"
    [caption]="user.displayName"
    [selected]="true"
    *ngFor="let user of owners"
    (click)="remove(user)"
    suffixIcon="close"
  >
  </elements-filter-chip>
</div>

<div class="actions">
  <button styles-button (click)="close.emit()">Filter</button>
  <button styles-low-button (click)="clear()">Clear</button>
</div>
